import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { TaskInformationModal } from './TaskInformationModal.component'

const withUnmountHoc = withUnmountTransition(TaskInformationModal)
export { withUnmountHoc as TaskInformationModal }
